import { useBreakpoint } from "@/hooks/useBreakpoint";
import { RailedCaseStudies } from "./railed-case-studies";
import { StackedCaseStudies } from "./stacked-case-studies";

// Desktop tree entry. Note: App.tsx only branches on isMobile (<768), so this
// component also serves tablet (768-1023) — where we drop the rail and use a
// plain 2-column stack.
export function CaseStudiesV2() {
  const { isDesktop } = useBreakpoint();

  if (isDesktop) {
    return <RailedCaseStudies />;
  }

  return (
    <section id="case-studies" className="px-6 py-20">
      <header className="mb-12 text-center">
        <h2 className="mb-4 font-body text-lg font-light text-foreground">
          CASE STUDIES
        </h2>
        <p className="font-heading text-4xl text-foreground">Selected Work</p>
      </header>
      <StackedCaseStudies columns={2} />
    </section>
  );
}
